import { useEffect, useState } from "react";
import Home from "@/pages/Home";
import Acchiappo from "@/pages/Acchiappo";
import { getPublicSettings } from "@/lib/api";

const host = () => window.location.hostname.replace(/^www\./, "").toLowerCase();
const CACHE = "leadders_acchiappo_host";

export default function RootPage() {
  const [isAcchiappo, setIsAcchiappo] = useState(() => localStorage.getItem(CACHE) === host());

  useEffect(() => {
    getPublicSettings().then((s) => {
      const dom = (s.acchiappo?.dominio || "").replace(/^https?:\/\//, "").replace(/^www\./, "").replace(/\/.*$/, "").toLowerCase();
      const match = !!dom && dom === host();
      if (match) localStorage.setItem(CACHE, dom); else localStorage.removeItem(CACHE);
      setIsAcchiappo(match);
    }).catch(() => {});
  }, []);

  return isAcchiappo ? <Acchiappo /> : <Home />;
}
